/**
 * Status Collection.
 *
 * Contains static list of available status, which can be used for different purposes, like
 * filling lists, allowing options selection, etc.
 */
export default [
  {
    key: 0,
    icon: {
      name: 'dot',
    },
    iconInOption: false,
    value: 'Draft',
    color: 'warning.700',
    backgroundColor: 'warning.50',
  },
  {
    key: 50,
    icon: {
      name: 'dot',
    },
    iconInOption: false,
    value: 'Active',
    color: 'success.700',
    backgroundColor: 'success.50',
  },
  {
    key: 80,
    icon: {
      name: 'dot',
    },
    iconInOption: false,
    value: 'Obsolete',
    color: 'gray.400',
    backgroundColor: 'gray.900',
  },
  {
    key: 90,
    icon: {
      name: 'dot',
    },
    iconInOption: false,
    value: 'Archived',
    color: 'error.700',
    backgroundColor: 'error.50',
  },
]
